import { rfqMoneyLabel, rfqDaysLabel } from "./rfq-presentation";
import type { RfqViewState } from "./rfq-view-types";
import type { Rfq } from "../../domain/rfq-types";
import { can } from "../../../../shared/auth/access";

type Props = Pick<RfqViewState,
  "user" |
  "rfq" |
  "offers" |
  "evaluation" |
  "governanceBusy" |
  "evaluateUnifiedOffers"
> & { rfq: Rfq };
export function RfqEvaluation({
  user,
  rfq,
  offers,
  evaluation,
  governanceBusy,
  evaluateUnifiedOffers,
}: Props) {
  return (
    <div
      className="rfq-unified-evaluation"
      role="region"
      aria-label="Birleşik teklif karşılaştırması"
    >
      <div className="rfq-invitations-heading">
        <div>
          <span className="section-kicker">Karşılaştırma</span>
          <h3>Manuel ve portal teklifleri</h3>
          <p>
            Yalnız sunucunun doğruladığı son teklif sürümleri aynı
            puanlama kurallarıyla karşılaştırılır. Sıralama satın alma
            kararı değildir.
          </p>
        </div>
        {can(user, "offer.manage") ? (
          <button
            className="secondary-button"
            disabled={
              governanceBusy ||
              (rfq.method === "SEALED" && !offers?.unsealed)
            }
            onClick={evaluateUnifiedOffers}
          >
            Teklifleri değerlendir
          </button>
        ) : null}
      </div>
      {rfq.method === "SEALED" && !offers?.unsealed ? (
        <p className="rfq-evaluation-locked">
          Kapalı teklifler açılmadan fiyat, belge ve ticari koşullar
          değerlendirmeye aktarılmaz.
        </p>
      ) : evaluation ? (
        <>
          <div className="rfq-evaluation-summary" role="status">
            <strong>Sürüm {evaluation.version}</strong>
            <span>
              {evaluation.status === "SINGLE_OFFER"
                ? "Yalnız bir geçerli teklif var; gerekçeli yetkili seçim gerekir."
                : evaluation.status === "NO_ELIGIBLE_OFFER"
                  ? "Karşılaştırılabilir geçerli teklif bulunamadı."
                  : evaluation.offers.filter(
                        (item) =>
                          item.totalScore !== null &&
                          item.totalScore ===
                            evaluation.offers.find(
                              (candidate) =>
                                candidate.id === evaluation.topOfferId,
                            )?.totalScore,
                      ).length > 1
                    ? "En yüksek puanda eşitlik var; nihai seçim otomatik yapılmaz."
                    : "Sıralama hazır; nihai seçim ayrı yetkili işlemde yapılır."}
            </span>
          </div>
          <div className="rfq-evaluation-list">
            {evaluation.offers.map((item) => (
              <article
                key={item.id}
                className={
                  item.exclusionReasons.length ? "is-excluded" : ""
                }
              >
                <div className="rfq-evaluation-title">
                  <div>
                    <strong>{item.supplier}</strong>
                    <span>{item.sourceLabel}</span>
                  </div>
                  <span>
                    {item.exclusionReasons.length
                      ? "Karşılaştırma dışı"
                      : item.rank
                        ? `${item.rank}. sıra`
                        : "Geçerli"}
                  </span>
                </div>
                {item.exclusionReasons.length ? (
                  <ul>
                    {item.exclusionReasons.map((reason) => (
                      <li key={reason}>{reason}</li>
                    ))}
                  </ul>
                ) : (
                  <dl>
                    <div>
                      <dt>Karşılaştırılabilir toplam</dt>
                      <dd>
                        {rfqMoneyLabel(item.comparableTotal, evaluation.comparisonCurrency)}
                      </dd>
                    </div>
                    <div>
                      <dt>Teslimat</dt>
                      <dd>{rfqDaysLabel(item.deliveryDays)}</dd>
                    </div>
                    <div>
                      <dt>Vade</dt>
                      <dd>{rfqDaysLabel(item.paymentDays)}</dd>
                    </div>
                    <div>
                      <dt>Puan</dt>
                      <dd>{item.totalScore ?? "—"}</dd>
                    </div>
                  </dl>
                )}
              </article>
            ))}
          </div>
        </>
      ) : (
        <p className="rfq-evaluation-empty">
          Henüz birleşik değerlendirme oluşturulmadı.
        </p>
      )}
    </div>
  );
}
